import { createSlice } from '@reduxjs/toolkit'
import {
  DICTIONARIE_VEHICLE_DOCUMENT_TYPE,
  type EditDictionarieState,
} from './types'

const initialState: EditDictionarieState = {
  documentOrgVehicle: {
    orders: [],
    order: {},
  },
  documentVehicle: {
    documents: [
      {
        series: 23454,
        number: 77846,
        start_date: '2023-07-31T19:12:48Z',
        end_date: '2023-07-31T19:12:48Z',
        issued: 'test_company',
        insurer: 'test',
      },
    ],
    document: {
      typeDocument: {
        value: DICTIONARIE_VEHICLE_DOCUMENT_TYPE.DSAGO_DOCUMENT,
        label: 'ДСАГО',
      },
    },
  },
}

export const editDictionarieSlice = createSlice({
  name: 'editDictionarie',
  initialState,
  reducers: {
    getDocument: (state) => {},
    setDocument: (state, { payload }) => {
      state.documentVehicle.document = payload
    },
  },
})

export const { getDocument, setDocument } = editDictionarieSlice.actions
